import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const sessionKey = (token) => `portal_session_${token}`;
export const getPortalSession = (token) => sessionStorage.getItem(sessionKey(token)) || localStorage.getItem(sessionKey(token));
export const setPortalSession = (token, session, remember) => {
  (remember ? localStorage : sessionStorage).setItem(sessionKey(token), session);
};
export const clearPortalSession = (token) => {
  sessionStorage.removeItem(sessionKey(token));
  localStorage.removeItem(sessionKey(token));
};

export function makePortalApi(token, onUnauthorized) {
  const inst = axios.create({ baseURL: `${BACKEND_URL}/api` });
  inst.interceptors.request.use((cfg) => {
    const s = getPortalSession(token);
    if (s) {
      cfg.headers = cfg.headers || {};
      cfg.headers.Authorization = `Bearer ${s}`;
    }
    return cfg;
  });
  inst.interceptors.response.use(
    (r) => r,
    (err) => {
      if (err?.response?.status === 401 && !String(err?.config?.url || "").includes("/public/")) {
        clearPortalSession(token);
        onUnauthorized?.(err?.response?.data?.detail);
      }
      return Promise.reject(err);
    }
  );
  return inst;
}

export function portalErr(err, fallback = "Etwas ist schiefgelaufen") {
  const d = err?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (err && !err.response) return `${fallback} — keine Verbindung`;
  return fallback;
}

export const fmtDate = (iso, withTime = false) => {
  if (!iso) return "—";
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", ...(withTime ? { hour: "2-digit", minute: "2-digit" } : {}) });
};

export const euro = (n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(n || 0);
